import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function PaymentDateModal({ isOpen, onClose, onConfirm, invoiceId }) {
  const [paymentDate, setPaymentDate] = useState("");

  const handleConfirm = () => {
    if (!paymentDate) {
      return;
    }
    onConfirm(paymentDate);
    setPaymentDate("");
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Ödeme Tarihini Girin</DialogTitle>
          <DialogDescription>
            Lütfen şu numaralı fatura için ödeme tarihini girin: #{invoiceId}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="paymentDate" className="text-right">
              Ödeme Tarihi
            </Label>
            <Input
              id="paymentDate"
              type="date"
              className="col-span-3"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            İptal
          </Button>
          <Button onClick={handleConfirm} disabled={!paymentDate}>
            Onayla
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
